<template>
  <v-dialog
    v-model="dialog"
    overlay
    persistent
    max-width="300px"
    transition="dialog-transition"
  >
    <template #activator="{ attrs }">
      <v-btn
        :loading="searching"
        @click="OpenOption"
        v-bind="attrs"
        icon
        color="success"
      >
        <v-icon>fas fa-users-cog</v-icon>
      </v-btn>
    </template>
    <v-card class="grey lighten-1">
      <v-toolbar dark class="grey" dense primary-title>
        <v-toolbar-title class="text-truncate">
          {{ ClientInfo.Name }}
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn icon @click="close">
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-list class="grey lighten-1">
          <v-subheader class="white--text"> Clients More Options </v-subheader>
          <v-list-item>
            <!-- <v-btn block color="primary" dark>text</v-btn> -->
            <old-balance
              :OnFinished="OpenOption"
              :disabled="isvalid"
              :client="ClientInfo"
            ></old-balance>
          </v-list-item>
          <!-- <v-list-item>
            <ClientDeposite
              :OnFinished="OpenOption"
              :disabled="isvalid"
              :client="ClientInfo"
            ></ClientDeposite>
          </v-list-item> -->
        </v-list>

        <!-- <p v-if="ErrMsg" v-html="ErrMsg" class="text-center error--text"></p> -->
        <!-- <v-divider></v-divider> -->
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <!-- <p>
        </p> -->
        <v-spacer></v-spacer>
        <cashDisplay
          small
          :isloading="searching"
          :Balance="Balance"
        ></cashDisplay>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import Axios from "axios";
import { mapGetters } from "vuex";

// import cashDisplay from "@/components/util/displayCash.vue";
export default {
  components: {
    OldBalance: () => import("@/components/Branches/Clients/OldBalance.vue"),
    // ClientDeposite: () =>
    //   import("@/components/Branches/Clients/ClientDeposit.vue"),
    cashDisplay: () => import("@/components/coman/cashViewNoRow.vue"),
  },
  props: {
    ClientInfo: { type: Object, required: true },
  },
  data() {
    return {
      BaseURL: "/customer",
      ErrMsg: "",
      searching: false,
      isvalid: false,
      dialog: false,
      ExpBalance: [],
    };
  },

  computed: {
    ...mapGetters(["UsersToken"]),
    Balance() {
      return this.ExpBalance.map(Amount => {
        if (Amount.Amount < 0) return { ...Amount, AccountName: "Balance" };
        return { ...Amount, AccountName: "Balance" };
      });
    },
  },
  methods: {
    close() {
      this.dialog = false;
      this.ErrMsg = "";
      this.ExpBalance = [];
    },

    GetReq(url, query) {
      return this.$store.dispatch("FIND_BY_VALUE", {
        url,
        query,
      });
    },
    OpenOption() {
      this.searching = true;
      this.ExpBalance = [];
      //   this.dialog = true;
      let cashUrl = this.BaseURL + "/balance";
      let validURL = this.BaseURL + "/validOld";
      let cashQuery = { _id: this.ClientInfo._id };
      Axios.all([
        this.GetReq(cashUrl, cashQuery),
        this.GetReq(validURL, cashQuery),
      ])
        .then(([blce]) => {
          // console.log(blce.data);
          this.ExpBalance = blce.data || [];
          //   console.log(data);
          // if (data) this.isvalid = true;
          // else this.isvalid = false;
          // console.log(data);

          this.dialog = true;
          this.searching = false;
        })
        .catch(err => {
          console.log(err);
          this.searching = false;
        });
    },
  },
};
</script>
